export const FRAMED_AUTH_REQUEST = 'career-framework:auth-request';
export const FRAMED_AUTH_TOKEN = 'career-framework:auth-token';

export type FramedAuthAccount = {
  username: string;
  name?: string;
};

export type FramedAuthRequestMessage = {
  type: typeof FRAMED_AUTH_REQUEST;
  scopes: string[];
};

export type FramedAuthTokenMessage = {
  type: typeof FRAMED_AUTH_TOKEN;
  accessToken: string;
  expiresOn: number;
  account: FramedAuthAccount;
};

const allowedParentOrigins = (process.env.REACT_APP_ALLOWED_PARENT_ORIGINS || '')
  .split(',')
  .map((origin) => origin.trim())
  .filter(Boolean);

export const isAllowedParentOrigin = (origin: string) => allowedParentOrigins.includes(origin);
